module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboarding-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v(_vm._s(_vm.$t('User List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Onboarding List')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goUserLists()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user_list.employee')))])]), (!_vm.isBrowsIncluding) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goPhotoLists()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user_photo_list.photo')))])]) : _vm._e(), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goChangeLists()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user_change_list.change')))])]), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goShopLists()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('shop_list.responsible_person')))])]), (_vm.isSystemManagement || _vm.isAppIncluding || _vm.isAppNotIncluded) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goRitireeLists()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user_list.retiree')))])]) : _vm._e(), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    on: {
      "click": function($event) {}
    }
  }, [_vm._v(_vm._s(_vm.$t('user_list.onboarding')))])])])])]), (_vm.notify) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert",
    class: _vm.notify.danger ? 'alert-danger' : 'alert-success'
  }, [_c('span', [_vm._v(_vm._s(_vm.notify.message))])])])]) : _vm._e(), (_vm.forbidden) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.message.forbidden')))])])])]) : _vm._e(), (!_vm.forbidden) ? _c('div', [(_vm.canRegister) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/onboarding/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Onboarding New')))])])], 1)]) : _vm._e(), _c('div', {
    staticClass: "row margin-top"
  }, [((_vm.users != null && _vm.users.length > 0) && _vm.searchCallbackFlag) ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.user_name')))]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.shop_name')))]), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.join_day')))]), _c('th', {
    staticClass: "col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.status')))]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.documents')))]), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('onboarding.label.progress')))]), _c('th', {
    staticClass: "col-sm-2"
  })])]), _c('tbody', _vm._l((_vm.users), function(user, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.attributes['user-name']) + "　" + _vm._s(user.attributes['user-firstname']))]), _c('td', [_vm._v(_vm._s(user.attributes['shop-name']))]), _c('td', [_vm._v(_vm._s(user.attributes['user-joinday-format']))]), _c('td', [_c('span', {
      staticClass: "label",
      class: _vm.statusClass(user.attributes['onboarding-status'])
    }, [_vm._v(_vm._s(user.attributes['onboarding-status-i18n']))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.submitted')) + " " + _vm._s(user.attributes['document-counts'].submitted))]), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.label.approved')) + " " + _vm._s(user.attributes['document-counts'].approved))]), (user.attributes['document-counts'].rejected > 0) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.rejected')) + " " + _vm._s(user.attributes['document-counts'].rejected))]) : _vm._e()]), _c('td', [(user.attributes['progress']) ? [_c('span', [_vm._v(_vm._s(user.attributes['progress'].ok) + " / " + _vm._s(user.attributes['progress'].total) + " " + _vm._s(_vm.$t('onboarding.label.check_ok')))]), _vm._v(" "), (user.attributes['progress'].ready) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.$t('onboarding.label.register_ready')))]) : _vm._e()] : _vm._e()], 2), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          _vm.goDetail(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('onboarding.button.detail')))])])])])
  }))])]) : _vm._e(), ((_vm.users == null || _vm.users.length <= 0) && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55fd182f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/onboarding-list.pug
// module id = 849
// module chunks = 1